import React from 'react'
import Chart from "react-apexcharts";
import WarehouseissueDatatable from "./WarehouseissueDatatable"
export default function Warehousetable() {
    const state = {
        stroke: {
          lineCap: "round",
        },
        options: {
          dataLabels: {
            enabled: false,
          },
          legend: {
            fontSize: "18px",
            fontWeight: "700",
            fontFamily: "Poppins",
            position: "bottom",
            horizontalAlign: "center",
    
            // labels: {
            //   show: true,
            //   name: "Total Issus",
            //   value: 263,
            // },
            
          },
    
          title: {
            text: "25",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 110,
            floating: false,
            style: {
              fontSize: "24px",
              fontWeight: "bold",
              color: "#000",
            },
          },
          subtitle: {
            text: "Issues",
            align: "center",
            margin: 10,
            offsetX: 0,
            offsetY: 135,
            floating: false,
            style: {
              fontSize: "20px",
              fontWeight: "300",
              color: "#000",
            },
          },
          // subtitle: {
          //   text: ,
          //   align: "center",
          //   margin: 10,
          //   offsetX: 0,
          //   offsetY: 105,
          //   floating: false,
          //   style: {
          //     fontSize: "14px",
          //     fontWeight: "bold",
          //     color: "#000",
          //   },
          // },
          labels: ["Major", "Minor"],
          colors: ["#FF0000", "#FFFF00"],
    
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: "83%",
                // labels: {
                //   show: true,
                //   name: "Total Issus",
                //   value: 263,
                // },
              },
            },
          },
        },
    
        series: [35, 65],
      };
  return (
    <div>
    
    <div className="mt-8 sm:w-full md:w-full">
        <div class=" shadow-slate-400 shadow-md bg-white rounded-2xl flex-1">
          <div className="flex flex-wrap mr-4 mt-2 pt-2">
            <h3 className="text-lg font-bold mx-3"> Issues Reported by Warehouse Staff</h3>
           {/* <div className="float-right ml-auto mr-4 mt-1">
              
              <div className="float-right">
                <button className="rounded-full w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-blue-200 text-lg font-bold text-white outline-1 mx-2">
                  {" "}
                  M
                </button>
              </div>
              <div className="float-right">
                <button className="rounded-full text-blue-900 w-8 hover:bg-white hover:text-black active:text-white active:bg-blue-200 bg-cyan-200 text-lg font-bold outline-1 mx-2">
                  {" "}
                  Y
                </button>
              </div>
              <div className="relative text-gray-600 mr-3 ml-10 float-right focus-within:text-gray-400">
                <span className="absolute text-slate-400 inset-y-0 left-0 flex items-center pl-2">
                  <button
                    type="submit"
                    className="p-1 focus:outline-none focus:shadow-outline"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4 6h16M4 12h8m-8 6h16"
                      />
                    </svg>
                  </button>
                </span>
                <input
                  type="search"
                  className="py-2 text-sm outline-slate-100 outline focus:outline-slate-200 rounded-full pl-10 focus:outline-1 focus:bg-white focus:text-gray-900"
                  placeholder="Filter"
                  autocomplete="off"
                />
              </div>
              <div class=" flex border-b border-b-violet-800 mr-8 ">
                <input
                  class="w-full rounded-lg p-2"
                  type="text"
                  placeholder="Search"
                />
                <button class=" w-auto flex justify-end items-center text-blue p-2 hover:text-blue-light">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.1206 13.7553L13.5772 9.87719C14.4317 8.87406 14.9369 7.64031 14.9369 6.30781C14.9369 2.95469 11.7409 0.226562 7.81186 0.226562C3.88358 0.226562 0.6875 2.95469 0.6875 6.30781C0.6875 9.66156 3.88358 12.3891 7.81186 12.3891C9.30116 12.3891 10.6843 11.9972 11.8295 11.3278L16.397 15.2266L18.1206 13.7553ZM2.77721 6.30781C2.77721 3.93781 5.03607 2.00969 7.81259 2.00969C10.5891 2.00969 12.848 3.93781 12.848 6.30781C12.848 8.67781 10.5891 10.6059 7.81259 10.6059C5.03534 10.6059 2.77721 8.67781 2.77721 6.30781Z"
                      fill="#1F78B4"
                    />
                  </svg>
                </button>
              </div>
            </div>*/}
          </div>

          <div className="flex">
              <Chart
                // className="sm:w-32"
                //@ts-ignore
                options={state.options}
                series={state.series}
                type="donut"
                width="380"
              />
            <div className="flex-4 md:overflow-x-auto overflow-x-auto  float-right flex-wrap -mt-4">
            <WarehouseissueDatatable/>
            
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
